import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { HttpClickHandler } from 'src/app/directives/http-click.directive';
import { ToastType } from 'src/app/classes/ToastType';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent extends BaseComponent implements OnInit {

  changePasswordForm: FormGroup;
  user: any;
  userId: any;
  userName: any;
  constructor(private commonService: CommonService) {
    super();

    this.changePasswordForm = new FormGroup({
      oldPassword: new FormControl(null, [Validators.required]),
      newPassword: new FormControl(null, [Validators.required]),
      confirmPassword: new FormControl(null, [Validators.required]),

    });
    this.user = this.authorizationService.getUser();
    this.userId = null;
    this.userName = this.user.userName;
  }

  ngOnInit(): void {
  }

  changePassword(httpClickHandler: HttpClickHandler): void {
    if (this.changePasswordForm.invalid) {
      httpClickHandler.enable();
      return;
    }

    let body = {};
    body["currentPassword"] = this.changePasswordForm.value.oldPassword,
      body["newPassword"] = this.changePasswordForm.value.newPassword,
      body["confirmNewPassword"] = this.changePasswordForm.value.confirmPassword,
      body["userId"] = this.user.userId
    if (this.changePasswordForm.value.newPassword == this.changePasswordForm.value.confirmPassword) {
      this.commonService.changeUserPassword(body, httpClickHandler).subscribe(data => {
        this.util.createToast(this.translatePipe.getLabel("success"), ToastType.SUCCESS);
        this.changePasswordForm.reset();
      });
    }
    else { this.util.createToast(this.translatePipe.getLabel("ERROR"), ToastType.ERROR); }

  }

}
